<template>
  <info-panel class="video-tile cursor-pointer w-full">
    <template slot="content">
      <div
        class="w-full relative" 
        @click.stop="selectVideo"
      >
        <div
          class="
            videoOverlay
            absolute
            w-full
            h-full
            bg-grey-800
            opacity-0
            flex
            items-center
            justify-center
            rounded-t-lg
          "
        >
          <gd-button primary>{{ highlight ? 'Selected' : 'Select' }}</gd-button>
          <!-- <feather-icon
            @click.stop="playVideo(video)"
            icon="PlayCircleIcon"
            class="icon"
            svgClasses="text-white playVideoIcon"
          /> -->
        </div>
        <div
          class="w-full h-full bg-center rounded-t-lg flex flex-col justify-between p-2"
          :style="{
            backgroundSize: 'cover',
            backgroundImage: backgroundImageUrl(
              typeof video.thumbnail != 'undefined' && video.thumbnail != ''
                ? video.thumbnail
                : ''
            ),
          }"
        >
          <div
            class="font-bold text-sm px-3 rounded-l-full rounded-r-full self-end"
            :class="video.is_published === 1 ? 'bg-c-green' : 'bg-c-red'"
          >
            {{ video.is_published === 1 ? 'Published' : 'Draft' }}
          </div>
          <div
            class="self-end text-white bg-black p-1 text-xs shadow-md"
            v-if="video.video_duration && !isNaN(video.video_duration)"
          >
            {{ getDuration(video.video_duration) }}
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex w-full px-3 justify-between items-center">
        <div class="flex flex-col items-center justify-center">
          <div class="flex flex-col justify-left w-full">
            <p class="text-sm">
              {{ video.name }}
              <span
                class="text-grey-600 animate-pulse"
                v-tooltip="{
                  content: 'Encoding in process',
                  classes: 'custom-tooltip',
                  delay: {
                    show: 200,
                    hide: 200,
                  },
                }"
              >
                <i
                  class="fa fa-circle-notch"
                  v-if="
                    [1].includes(video.video_source_type) &&
                    (!video.video_encoding || !video.video_encoding.is_complete)
                    /** uploaded videos */
                  "
                ></i>
              </span>
            </p>
          </div>
          <div class="flex justify-left w-full pt-1">
            <p class="text-sm text-grey-600">
              {{ $t('frontend_groovevideo_videos_index_updated') }}
              {{ video.readable_updated_at }}
            </p>
            <div
              class="
                w-5
                h-5
                rounded-full
                text-white text-xs
                bg-pink
                flex
                items-center
                justify-center
                mx-1
              "
              :class="[highlight ? 'visible' : 'invisible']"
            >
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center">
          <drop-menu
            class="video-nav-dropmenu justify-between"
            :menu-items="getMenuItems(video)"
            small
          ></drop-menu>
          <div
            class="text-grey-600 flex justify-end"
            v-if="video.video_source_type"
            v-tooltip="{
              content: getSourceTypeName(video.video_source_type),
              classes: 'custom-tooltip',
              delay: {
                show: 200,
                hide: 200,
              },
            }"
          >
            <span v-if="video.video_source_type === 1"
              ><i class="fas fa-cloud-upload-alt"></i
            ></span>
            <span v-else-if="video.video_source_type === 2"
              ><i class="fab fa-youtube"></i
            ></span>
            <span v-else-if="video.video_source_type === 3"
              ><i class="fa fa-link"></i
            ></span>
          </div>  
        </div>
      </div>
    </template>
  </info-panel>
</template>
<script>
import moment from 'moment';
import { VTooltip } from 'v-tooltip';
import InfoPanel from '../InfoPanel';
import FeatherIcon from '../FeatherIcon';
import GdButton from '../Button';

export default {
  name: 'VideoTile',
  directives: { VTooltip },
  props: {
    video: {},
    highlight: {
      default: () => false,
    },
  },
  methods: {
    playVideo(video) {
      this.$emit('playVideo', video);
    },
    selectVideo() {
      this.$emit('selectVideo', this.video);
    },
    backgroundImageUrl(url) {
      return `url("${url}")`;
    },
    getDuration(duration) {
      if (duration >= 3600) {
        return moment().startOf('day').seconds(duration).format('HH:mm:ss');
      }

      if (duration < 3600) {
        return moment().startOf('day').seconds(duration).format('mm:ss');
      }

      return '00:00';
    },
    getSourceTypeName(type) {
      let name = this.$t('frontend_groovevideo_videos_index_mp4_url');

      if (type === 1) {
        name = this.$t('frontend_groovevideo_videos_index_uploaded');
      } else if (type === 2) {
        name = this.$t('frontend_groovevideo_videos_index_youtube_url');
      }

      return name;
    },
    getMenuItems(video) {
      return [
        {
          text: video.is_published === 0 ? this.$t('frontend_groovevideo_publish') : this.$t('frontend_groovevideo_unpublish'),
          callback: () => this.togglePublish(video.id),
        },
      ];
    },
    async togglePublish(videoId) {
      this.$emit('togglePublish', videoId);
    },
  },
  components: { InfoPanel, FeatherIcon, GdButton },
};
</script>
<style lang="scss">
.video-tile {
  .text-sm {
    font-size: 14px;
  }
  .playVideoIcon {
    stroke-width: 1;
    width: 80px;
    height: 84px;
  }
  .videoOverlay {
    transition: opacity 0.5s ease-out;
    -moz-transition: opacity 0.5s ease-out;
    -webkit-transition: opacity 0.5s ease-out;
    -o-transition: opacity 0.5s ease-out;
    &:hover {
      background-color: rgba(41, 44, 72, 0.79);
      opacity: 1;
    }
  }
  .bg-c-green {
    background-color: #cfecdb;
    color: #43b06f;
  }
  .bg-c-red {
    background-color: #fbe8d7;
    color: #ee9b5d;
  }
  .video-nav-dropmenu {
    width: 20px;
    height: 40px;
    .h-13 {
      width: 20px;
      height: 40px;
    }
    .mt-13 {
      margin-top: 40px;
    }
  }
}
</style>
